<template>
  <div class="coin-card-reward" v-if="rewards.length">
    <b-form-group>
      <base-select
      v-model="selectedReward"
      :options="rewards"
      :clearable="false"
      :searchable="true"
      selectClass="select-shadowed"
      :appendToBody="true"
      :placeholder="'Set coin card'"
      @input="setReward"
      >
        <template #option="opt">
          <span> {{ $t('{points}-valueof-{price}', { points: opt.points, price: opt.discount })}}</span>
        </template>
      </base-select>
    </b-form-group>
  </div>
</template>

<script>
import { EventBus } from '@/helpers'
import BaseSelect from 'theme/components/Form/BaseSelect'

export default {
  name: 'CardRewards',
  props: {
    // all user reward
    rewards: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selectedReward: undefined
    }
  },
  computed: {
    activeRew () {
      return this.$store.getters['cart/getActiveLoyalty']
    },
    totalCartAmount () {
      return this.$store.getters['cart/totalAmount']
    },
    remappedReward () {
      const _this = this
      if (this.rewards && this.rewards.length) {
        return this.rewards.filter((reward) => {
          return _this.totalCartAmount > reward.discount
        })
      } else {
        return []
      }
    }
  },
  methods: {
    init () {
      if (!this.selectedReward) {
        const _this = this
        this.selectedReward = this.rewards.find((rew) => rew.code === _this.activeRew)
      }
    },
    setReward ($event) {
      this.$store.commit('ui/showLoader')
      return this.$store.dispatch('cart/setRewardOnCart', $event)
        .then(() => {
          EventBus.$emit('checkout:updResume')
        })
        .finally(() => {
          this.$store.commit('ui/hideLoader')
        })
    }
  },
  components: {
    BaseSelect
  }
}
</script>
